import { DashboardItem } from 'src/types/dashboard'

const GRID_COLUMNS = 12

export interface GapInfo {
  insertIndex: number
  width: number
}

export function calculateGaps(items: DashboardItem[]): GapInfo[] {
  const gaps: GapInfo[] = []
  let usedInRow = 0

  for (let i = 0; i < items.length; i++) {
    if (usedInRow + items[i].width > GRID_COLUMNS) {
      const remaining = GRID_COLUMNS - usedInRow
      if (remaining > 0) {
        gaps.push({ insertIndex: i, width: remaining })
      }
      usedInRow = 0
    }

    usedInRow += items[i].width

    if (usedInRow === GRID_COLUMNS) {
      usedInRow = 0
    }
  }

  if (usedInRow > 0) {
    const remaining = GRID_COLUMNS - usedInRow
    if (remaining > 0) {
      gaps.push({ insertIndex: items.length, width: remaining })
    }
  }

  return gaps
}
